import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Register"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-register',
    templateUrl: './icon-cash-register.component.html',
    styleUrls: ['./icon-cash-register.component.scss'],
    standalone: false
})
export class IconCashRegisterComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
